
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gZn0sdhBPJMbdq7ekSKv2N07FNqcjdv6i1ANsoHL8IEIMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indext_45WRysTqEoIib7ZVgiuv6QMKX2Vmtes7cHZzCHxxmfIMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchWpSfdpyC9BKXGRJEAv7L4AXqgPJWfyfI7bc4QSaol3UMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexECCcNbL0q7V_NFBSKDErpIwX_45JJdkgUnAj0RSTo1ZWUMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93UUB5t_HbA1536hdTJCGTyeKFv5L0wCEEiDHjzMU0a_45EMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexyG_45e2xYIzccyd9_45Cfv1nluIrZLkQj1iso_45mFqVjHV4UMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93WCyMxgxw1f4P_jrfYQZKHAu3lccCiNrV3aJ1kNEdTmkMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexS0ugG073dlo7jk8Cxiy7HVA6wRp7LD_07RYRydXMggwMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93bkNB5YYYNjmTUzfm_45CqQL5EevEgXyM2Krqi0h5KZ7gcMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexWnW9YNqzDS7V0WMyiHp9Q9De_4574BbLwPHvN_EQynXZAMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index1cBv00JlsNAtridUTODBC1WTvcMpvZiJTJjOeQxzBkMMeta } from "/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexyG_45e2xYIzccyd9_45Cfv1nluIrZLkQj1iso_45mFqVjHV4UMeta || {},
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexS0ugG073dlo7jk8Cxiy7HVA6wRp7LD_07RYRydXMggwMeta || {},
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexWnW9YNqzDS7V0WMyiHp9Q9De_4574BbLwPHvN_EQynXZAMeta || {},
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index1cBv00JlsNAtridUTODBC1WTvcMpvZiJTJjOeQxzBkMMeta || {},
    component: () => import("/codebuild/output/src692227001/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]